import _ from 'lodash'
import api, { formCfg, listDehydrate } from './api'
import apiFactory from './api-factory'

const entryTag = {
  ...apiFactory('/api/polls/entry_tag/', ['getList', 'create', 'delete'], {
    hydrate,
    dehydrate,
  }),

  getTag(pk) {
    return api
      .get(`/api/polls/entry_tag/${pk}/`)
      .then((response) => dehydrate(response.data))
  },

  getRelatedTagsByTag(pk) {
    return api
      .get(`/api/polls/entry_tag/${pk}/related/`)
      .then((response) => listDehydrate(response.data, dehydrate))
  },

  getAllList(params) {
    return api
      .get('/api/polls/entry_tag/all/', formCfg(params, null))
      .then((response) => listDehydrate(response.data, dehydrate))
  },

  getUnapprovedList(params, context) {
    return api
      .get('/api/polls/entry_tag/unapproved/', formCfg(params, context))
      .then((response) => listDehydrate(response.data, unapprovedDehydrate))
  },

  getAncestors(pk) {
    return api
      .get(`/api/polls/entry_tag/${pk}/ancestors/`)
      .then((response) => listDehydrate(response.data, dehydrate))
  },

  approve(pk, params, context) {
    return api.put(
      `/api/polls/entry_tag/${pk}/approve/`,
      formCfg(params, context)
    )
  },

  refuse(pk, params, context) {
    return api.put(
      `/api/polls/entry_tag/${pk}/refuse/`,
      formCfg(params, context)
    )
  },

  setRelated(pk, relatedTags) {
    return api
      .post(`/api/polls/entry_tag/${pk}/set_related/`, { relatedTags })
      .then((response) => dehydrate(response.data))
  },

  search({ searchText, groupPk }) {
    // Use existing `api.get(...)`
    // We'll reuse your standard dehydrating approach
    return api
      .get('/api/polls/entry_tag/search/', {
        params: { q: searchText, group: groupPk },
      })
      .then((response) => listDehydrate(response.data, dehydrate))
  },
}

function unapprovedDehydrate({ pk, name, approved, level, parents }) {
  return {
    pk,
    name,
    approved,
    level,
    parents: _.map(parents, dehydrate),
  }
}

export function dehydrate({
  pk,
  name,
  language,
  childrenCount,
  relatedCount,
  entryTagGroup,
  approved,
  parentTag,
  level,
  ancestry,
}) {
  return {
    pk,
    name,
    language,
    entryTagGroup,
    childrenCount,
    relatedCount,
    approved,
    parentTag,
    level,
    ancestry,
  }
}

export function hydrate({ name, parentTag, relatedTags }) {
  return {
    name,
    parentTag,
    relatedTags,
  }
}

export default entryTag
